import { withPlatformSpecific } from '../HOCs/withPlatformSpecific/withPlatformSpecific';
import NativeNotificationsProvider from './NativeNotificationsProvider';
import WebNotificationsProvider from './WebNotificationsProvider';

export default withPlatformSpecific({
  NativeComponent: NativeNotificationsProvider,
  WebComponent: WebNotificationsProvider,
});
